import { z } from 'zod';

export const INTERCOM_HISTORY_IMPORT_STATUSES = ['running', 'paused', 'completed'] as const;
export type IntercomHistoryImportStatus = (typeof INTERCOM_HISTORY_IMPORT_STATUSES)[number];

export const INTERCOM_HISTORY_IMPORT_PHASES = ['open', 'history', 'retry'] as const;
export type IntercomHistoryImportPhase = (typeof INTERCOM_HISTORY_IMPORT_PHASES)[number];

export const INTERCOM_HISTORY_IMPORT_DEFAULT_FLOOR = '2016-01-01';

export const IntercomHistoryImportSchema = z.object({
  id: z.uuid(),
  status: z.enum(INTERCOM_HISTORY_IMPORT_STATUSES),
  phase: z.enum(INTERCOM_HISTORY_IMPORT_PHASES),
  floorDate: z.iso.date(),
  force: z.boolean(),
  windowDay: z.iso.date().nullable(),
  openTotal: z.number().int().nonnegative().nullable(),
  historyTotal: z.number().int().nonnegative().nullable(),
  scanned: z.number().int().nonnegative(),
  imported: z.number().int().nonnegative(),
  unchanged: z.number().int().nonnegative(),
  noMemberMessage: z.number().int().nonnegative(),
  failed: z.number().int().nonnegative(),
  lastError: z.string().nullable(),
  resumeAfter: z.iso.datetime().nullable(),
  startedAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
  finishedAt: z.iso.datetime().nullable(),
});
export type IntercomHistoryImport = z.infer<typeof IntercomHistoryImportSchema>;

export const IntercomHistoryImportStateSchema = z.object({
  run: IntercomHistoryImportSchema.nullable(),
});
export type IntercomHistoryImportState = z.infer<typeof IntercomHistoryImportStateSchema>;

export const StartIntercomHistoryImportSchema = z.object({
  floorDate: z.iso.date().optional(),
  force: z.boolean().optional(),
});
export type StartIntercomHistoryImport = z.infer<typeof StartIntercomHistoryImportSchema>;
